import React from "react";
import { Container, Image } from "react-bootstrap";
import { NavBar } from "./components/NavBar";
import { Footer } from "./components/Footer";
import BookNowWizard from "./BookNowWizard";
// import { BannerSection } from "./components/BannerSection";
import "font-awesome/css/font-awesome.min.css";
import DatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { de } from 'date-fns/locale/de';
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { useState } from "react";
import { Link } from "react-router-dom";
import { colors } from "@material-ui/core";

registerLocale('de', de);
setDefaultLocale('de');

export type HotelLandingProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

export type HotelLandingState = {
  showAuthenticationModal?: boolean;
  payload: AuthorizationResponsePayload;
};

export const HotelLanding = (props: HotelLandingProps, state: HotelLandingState) => {

  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [showBookingWizard, setShowBookingWizard] = useState(false);

  const showLoginDialog = () => {
    if (props.onApply) props.onApply();
  };

  const getPayload = (): AuthorizationResponsePayload => {
    return props.payload ?? state.payload;
  };

  return (
    <Container style={{ maxWidth: "100%", padding: "0px" }}>
      <NavBar />
      <div className="banner-section">
        <Image
          style={{ width: "100%" }}
          src={require("./main-iamge.jpeg")}
        ></Image>
        <div className="content-box">
          <span
            className="sub-title"
            data-animation-in="fadeInUp"
            data-delay-in="0.1" style={{color: "#fff"}}
          >
            unique place and luxury hotel
          </span>
          <h1 data-animation-in="fadeInUp" style={{color: "#fff"}} data-delay-in="0.3">
            enjoy life with <br />
            the best moments
          </h1>
          <div className="d-flex justify-content-center">
            <Link to={"/hotel/traveler-profile"}>
              <div className="outter-box">
                <button
                  className="ml-auto header-btn"
                  type="submit"
                  style={{ margin: "0 10px", width: "220px" }}
                >
                  Your Traveler Profile
                </button>
              </div>
            </Link>
            <Link to={"/hotel/check-in"}>
              <div className="outter-box">
                <button
                  className="ml-auto header-btn"
                  type="submit"
                  style={{ margin: "0 10px", width: "120px" }}
                >
                  Pre Check In
                </button>
              </div>
            </Link>
            <Link to={"/hotel/check-out"}>
              <div className="outter-box">
                <button
                  className="ml-auto header-btn"
                  type="submit"
                  style={{ margin: "0 10px", width: "120px" }}
                >
                  Check Out
                </button>
              </div>
            </Link>
          </div>
        </div>

        <div className="checkout-form-section wow slideInUp">
          <div className="auto-container">
            <div className="checkout-form">
              <div className="checkout-field">
                <h6>Check in</h6>
                <div className="chk-field">
                <DatePicker
                  selected={startDate}
                  onChange={(date:any) => setStartDate(date)}
                  className="form-control"
                  locale="de"
                  placeholderText="When do you arrive"
                />
                </div>
              </div>
              <div className="checkout-field">
                <h6>Check out</h6>
                <div className="chk-field">
                <DatePicker
                  selected={endDate}
                  onChange={(date:any) => setEndDate(date)}
                  className="form-control"
                  locale="de"
                  placeholderText="When do you leave"
                />
                </div>
              </div>
              <div className="checkout-field br-0">
                <h6>Number of persons</h6>
                <div className="chk-field">
                  <i className="fa fa-angle-down"></i>
                  <select>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
              </div>
              <a href="#booknow-wizard" onClick={() => setShowBookingWizard(true)} data-animation-in="fadeInUp" data-delay-in="0.5" className="theme-btn btn-style-one" >
                <span className="btn-title">check now</span>
              </a>
            </div>
          </div>
        </div>

        <div
        id="booknow-wizard"
        className="pre-check-in-box"
        style={{ margin: "200px 100px 0px 100px" }}
      >
        {showBookingWizard && (
          <BookNowWizard payload={getPayload()} startDate={startDate != undefined?startDate.toLocaleDateString() : ""} endDate={endDate != undefined?endDate.toLocaleDateString() : ""}
          onApply={() => showLoginDialog()} />
        )}
        
      </div>
      </div>

      <Footer></Footer>
    </Container>
  );
};
